import { createContext, useContext, ReactNode } from 'react';

interface AudienceIdentity {
  sessionId: string | null;
  audienceId: string | null;
  teamColor: string | null;
  nickname: string | null;
  isSpectator: boolean;
}

const AudienceIdentityContext = createContext<AudienceIdentity>({
  sessionId: null,
  audienceId: null,
  teamColor: null,
  nickname: null,
  isSpectator: false,
});

/**
 * Legge l'identità audience dal context se disponibile, altrimenti da localStorage.
 */
export function useAudienceIdentity(): AudienceIdentity {
  const ctx = useContext(AudienceIdentityContext);
  if (ctx.isSpectator) return ctx;

  // Fallback a localStorage (comportamento standard)
  return {
    sessionId: localStorage.getItem('sessionId'),
    audienceId: localStorage.getItem('audienceId'),
    teamColor: localStorage.getItem('teamColor'),
    nickname: localStorage.getItem('nickname'),
    isSpectator: false,
  };
}

/**
 * Provider per modalità spectator: bypassa localStorage.
 */
export function SpectatorProvider({
  sessionId,
  teamColor,
  audienceId,
  children,
}: {
  sessionId: string;
  teamColor: string;
  audienceId: string;
  children: ReactNode;
}) {
  return (
    <AudienceIdentityContext.Provider
      value={{
        sessionId,
        audienceId,
        teamColor,
        nickname: `__spectator_${teamColor.toLowerCase()}`,
        isSpectator: true,
      }}
    >
      {children}
    </AudienceIdentityContext.Provider>
  );
}

export default AudienceIdentityContext;
